/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DocumentOcrAnalysisViewModel } from "../types/DocumentOcrAnalysisViewModel.ts";
import { documentOcrStatusesViewModelSchema } from "./documentOcrStatusesViewModelSchema.ts";

export const documentOcrAnalysisViewModelSchema = z.object({
  documentsStatus: z.optional(z.lazy(() => documentOcrStatusesViewModelSchema)),
  generalStatus: z
    .string()
    .describe(
      'Status geral da matrícula: "aprovado", "aprovado_provisorio" ou "revisao_humana".',
    )
    .nullish(),
  expiredDocuments: z
    .array(z.string())
    .describe(
      'Nomes dos documentos com validade vencida ("rg", "cpf", "diploma").',
    )
    .nullish(),
  documentsLanguage: z
    .string()
    .describe(
      "Código do idioma predominante dos documentos (PT, EN ou ES). Opcional.",
    )
    .nullish(),
  needsTranslation: z.optional(
    z
      .boolean()
      .describe(
        "Indica se os documentos exigem tradução (idioma fora de PT/EN/ES).",
      ),
  ),
  readableDocuments: z.optional(
    z.boolean().describe("Indica se os documentos estão legíveis."),
  ),
  discrepancies: z
    .array(z.string())
    .describe(
      "Divergências relevantes entre os documentos e os dados do sistema.",
    )
    .nullish(),
  generalNotes: z
    .string()
    .describe("Observações gerais da análise. Opcional.")
    .nullish(),
}) as unknown as ToZod<DocumentOcrAnalysisViewModel>;
